<script>
    import TagContainer from '@/components/base-components/TagContainer.vue';
    import {tagAddInList, tagRemoveInList} from '@/scripts/tag.js';


    export default {
        data() {
            return {
                tagValue: '',
            }
        },
        props: {
            file: Object,
        },
        components: {
            TagContainer: TagContainer,
        },
        methods: {
            async clearTag() {
                await this.file.clearTags();
            },
            async addTag() {
                const newSelectTag = await tagAddInList(this.file.tags, this.tagValue);
                this.tagValue = '';
                await this.file.setTags(newSelectTag);
            },
            async RemoveTag(tagID) {
                const newSelectTag = await tagRemoveInList(this.file.tags, tagID);
                await this.file.setTags(newSelectTag);
            }
        }
    }
</script>


<template>
    <div class="image_tags">
        <label>Tags:</label>
        <div class="image_tags_header mt_5">
            <input 
                type="text" 
                list="tagList"
                v-model="tagValue"
                placeholder="start typing the tag"
            >
            <button 
                class="button_blue_150 ml_5"
                @click="addTag"
            >
                Add
            </button>
            <button 
                class="button_blue_150 ml_5"
                @click="clearTag"
            >
                Clear Tag
            </button>
        </div>
        <div class="image_tags_container">
            <TagContainer 
                v-for="(tagValue, tagIndex) in file['tags']" :key="tagIndex"
                tag-color="tag"
                :tag-i-d="tagValue"
                @deleteTag = "RemoveTag"
            />
        </div>
    </div>
</template>


<style scoped>
    .image_tags {
        padding: 10px;
    }
    
    .image_tags_header {
        display: flex;
        flex-direction: row;
    }
    .image_tags_header > input {
        width: 500px;

        border: var(--border);
        border-radius: 5px;

        font-size: 14px;
        padding: 5px;
    }

    .image_tags_container {
        margin-top: 5px;
        display: flex;
        flex-wrap: wrap;
    }
</style>